// XR Movie Database (Final Shopify-Compatible Version)
// Loads movies from xr-movies.json (Shopify asset)
// Sends new submissions to Google Apps Script (sheet backend)

window.xrMoviesLoaded = true; // Debug flag

// === CONFIG ===
// *** YOUR REAL GOOGLE SCRIPT URL ***
const FORM_API = "https://script.google.com/macros/s/AKfycbxb4OK36eCtMNW2NMvoSrwSuR4IT5PypHvY59vyq6cZieVsB4Ovm9_0eAjcQ9zSKaIG/exec";

let allMovies = [];
let loadedCount = 0;
const batchSize = 10;

// Fire once the DOM is ready
document.addEventListener("DOMContentLoaded", () => {
  setupScroll();
  setupSearch();
  setupSorting();
  setupForm();
  fetchMovies();
});

// === LOAD MOVIES FROM JSON ===
async function fetchMovies() {
  try {
    if (!window.XR_MOVIE_API) {
      throw new Error("XR_MOVIE_API not defined");
    }

    const res = await fetch(window.XR_MOVIE_API);
    const data = await res.json();

    allMovies = data.movies || [];

    sortMovies("az");
    renderNextBatch();
  } catch (err) {
    console.error("Failed to load movies:", err);
    const list = document.getElementById("xr-3d-movies");
    if (list) {
      list.innerHTML = `<p style="color:red;">Error loading movies.</p>`;
    }
  }
}

// Render movies in chunks
function renderNextBatch() {
  const list = document.getElementById("xr-3d-movies");
  const loader = document.getElementById("xr-loader");
  if (!list) return;

  const end = loadedCount + batchSize;
  const movies = allMovies.slice(loadedCount, end);

  movies.forEach(movie => list.appendChild(createMovieCard(movie)));
  loadedCount = end;

  if (loadedCount >= allMovies.length) {
    if (loader) loader.style.display = "none";

    const endMsg = document.createElement("p");
    endMsg.style.textAlign = "center";
    endMsg.style.color = "#777";
    endMsg.style.padding = "1rem";
    endMsg.innerText = "End of list.";
    list.appendChild(endMsg);
  } else {
    if (loader) loader.style.display = "block";
  }
}

// Build a movie card
function createMovieCard(movie) {
  const card = document.createElement("div");
  card.className = "xr-movie-card";

  const poster = movie.poster || "https://via.placeholder.com/500x750?text=No+Poster";

  card.innerHTML = `
    <img class="xr-poster-img" src="${poster}" alt="${movie.title}">
    <div>
      <h3>${movie.title}</h3>
      <a class="xr-open-gtv-btn" href="${movie.url}" target="_blank">
        Open in Google TV
      </a>
      <p style="margin-top:0.5rem;font-size:0.9rem;color:#444;">
        Submitted by: ${movie.username || "Anonymous"}
      </p>
      ${movie.notes ? `<p style="font-size:0.85rem;color:#666;">${movie.notes}</p>` : ""}
      <p style="font-size:0.85rem;color:#888;margin-top:0.5rem;">
        ${movie.votes || 0} Upvotes
      </p>
    </div>
  `;

  return card;
}

// === SEARCH ===
function setupSearch() {
  const search = document.getElementById("xr-search");
  if (!search) return;

  search.addEventListener("input", () => {
    const term = search.value.toLowerCase();
    const list = document.getElementById("xr-3d-movies");
    const loader = document.getElementById("xr-loader");
    if (!list) return;

    const filtered = allMovies.filter(m =>
      m.title.toLowerCase().includes(term)
    );

    list.innerHTML = "";
    filtered.forEach(m => list.appendChild(createMovieCard(m)));

    if (loader) loader.style.display = "none";
  });
}

// === SORTING ===
function setupSorting() {
  const sortSelect = document.getElementById("xr-sort");
  if (!sortSelect) return;

  sortSelect.addEventListener("change", () => {
    const method = sortSelect.value;
    sortMovies(method);

    loadedCount = 0;
    const list = document.getElementById("xr-3d-movies");
    if (!list) return;

    list.innerHTML = "";
    renderNextBatch();
  });
}

function sortMovies(method) {
  if (method === "az") {
    allMovies.sort((a, b) => a.title.localeCompare(b.title));
  } else if (method === "za") {
    allMovies.sort((a, b) => b.title.localeCompare(a.title));
  } else if (method === "newest") {
    allMovies.sort((a, b) => new Date(b.timestamp || 0) - new Date(a.timestamp || 0));
  } else if (method === "votes") {
    allMovies.sort((a, b) => (b.votes || 0) - (a.votes || 0));
  }
}

// === INFINITE SCROLL ===
function setupScroll() {
  const container = document.getElementById("xr-list-container");
  if (!container) return;

  container.addEventListener("scroll", () => {
    if (container.scrollTop + container.clientHeight >= container.scrollHeight - 10) {
      renderNextBatch();
    }
  });
}

// === FORM SUBMISSION TO GOOGLE SCRIPT ===
function setupForm() {
  const form = document.getElementById("xr-3d-form");
  const messageEl = document.getElementById("xr-form-message");
  const submitBtn = document.getElementById("xr-submit-btn");

  if (!form) return;

  form.addEventListener("submit", async (e) => {
    e.preventDefault();

    if (!FORM_API) {
      if (messageEl) {
        messageEl.textContent = "Submission endpoint is not configured.";
        messageEl.style.color = "red";
      }
      return;
    }

    if (submitBtn) {
      submitBtn.disabled = true;
      submitBtn.textContent = "Submitting…";
    }
    if (messageEl) {
      messageEl.textContent = "";
    }

    try {
      const formData = new FormData(form);

      await fetch(FORM_API, {
        method: "POST",
        body: formData,
        mode: "no-cors"
      });

      if (messageEl) {
        messageEl.textContent = "✅ Thanks! Your movie was submitted.";
        messageEl.style.color = "green";
      }

      form.reset();

    } catch (err) {
      console.error("Submit failed:", err);
      if (messageEl) {
        messageEl.textContent = "❌ There was a problem submitting. Please try again later.";
        messageEl.style.color = "red";
      }
    } finally {
      if (submitBtn) {
        submitBtn.disabled = false;
        submitBtn.textContent = "Submit Movie";
      }
    }
  });
}
